import { Injectable, ElementRef } from '@angular/core';
import { OnDemandPreloadService, OnDemandPreloadOptions } from './preloadOnDemandService';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { LoggerService } from './logger/logger.service';

@Injectable({ providedIn: 'root', deps: [OnDemandPreloadService] })
export class OnDemandPreloadStrategy implements PreloadingStrategy {
  private preloadOnDemand$: Observable<OnDemandPreloadOptions>;

  constructor(private preloadOnDemandService: OnDemandPreloadService,  private loggerService:LoggerService,
  ) {
    this.preloadOnDemand$ = this.preloadOnDemandService.state;
  }

  preload(route: Route, load: () => Observable<any>): Observable<any> {


    return this.preloadOnDemand$.pipe(
      mergeMap(preloadOptions => {
        const shouldPreload = this.preloadCheck(route, preloadOptions);
      
                if (shouldPreload){
                  console.log ("  I am going to load this now ...", route);
                  return load ();
                }

                return EMPTY;
      })
    );
  }

  private preloadCheck(route: Route, preloadOptions: OnDemandPreloadOptions) {

     if (
        route.data &&
        route.data['preload'] 
      ){
          return true;
      }

    if (preloadOptions.preload && route.path == preloadOptions.routePath){
        return true;
    }

    return false;
   
  }
}
